import chunkArray from "../../../utils/chunkArray";

export function calculatePaginatedDataKeys(initialRowKeys, keysPerPage) {

    let chunkedRowKeys;

    if ( initialRowKeys.length <= keysPerPage ) {
        // can skip chunking algorithm if there will only be one page of data.
        chunkedRowKeys = [[...initialRowKeys]];  // maintain expected format of an array of arrays
    } else {
        chunkedRowKeys = chunkArray(initialRowKeys, keysPerPage);
    }

    return chunkedRowKeys

}
